import { useEffect, useState } from 'react';
import { Keyboard, Platform, type KeyboardEvent } from 'react-native';

export interface KeyboardState {
  visible: boolean;
  height: number;
}

/**
 * Tracks the on-screen keyboard. iOS exposes the "will" events (so we can react
 * before the keyboard finishes animating); Android only reliably emits the
 * "did" events.
 */
export const useKeyboard = (): KeyboardState => {
  const [state, setState] = useState<KeyboardState>({
    visible: false,
    height: 0,
  });

  useEffect(() => {
    const showEvent =
      Platform.OS === 'ios' ? 'keyboardWillShow' : 'keyboardDidShow';
    const hideEvent =
      Platform.OS === 'ios' ? 'keyboardWillHide' : 'keyboardDidHide';

    const onShow = (e: KeyboardEvent) => {
      setState({ visible: true, height: e.endCoordinates.height });
    };
    const onHide = () => {
      setState({ visible: false, height: 0 });
    };

    const showSub = Keyboard.addListener(showEvent, onShow);
    const hideSub = Keyboard.addListener(hideEvent, onHide);

    return () => {
      showSub.remove();
      hideSub.remove();
    };
  }, []);

  return state;
};
